import React, {Component} from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import '../CSS/subscriptions.css';
//import Promise from 'promise-polyfill';
import { Switch, Route, Link } from 'react-router-dom'
import moment from 'moment'
import Select from 'react-select';
import SpiffyCare from '../images/spiffy_care.png'
import WorkIcon from '../images/business.png'
import HomeIcon from '../images/home.png'
import Sedan from '../images/spiffysedan.svg'
import NonSedan from '../images/nonsedan.svg'
import 'react-select/dist/react-select.css';


// if (!window.Promise) {
//   window.Promise = Promise;
// }
class SubscriptionSummary extends Component {

  constructor(props) {
    super(props);
  }

  componentWillReceiveProps(nextProps){
  }
  render(){
      return (

        <div>
          <div className="card">
            <div className="card-title gray-background text-center">
              <img width="25%" src={SpiffyCare}></img>
            </div>
            <div className="card-title bg-white">
              <div className="row align-items-center mb-2">
              <div className="col">
                <h6 className="card-subtitle ml-3">Location: {this.props.subscription.address.display_title}<br></br>{this.props.subscription.address.street}</h6>
              </div>
                <div className="col text-right mr-3">
                {(this.props.subscription.address.rdi == 'Residential') &&
                  <img className="icon" width="15%" src={HomeIcon}></img>}
                {(this.props.subscription.address.rdi != 'Residential') &&
                    <img className="icon" width="15%" src={WorkIcon}></img> }
                </div>
                </div>
            </div>
            <hr></hr>
            <div className="card-title bg-white">
              <div className="row align-items-center mb-2">
              <div className="col">
                <h6 className="card-subtitle ml-3">Vehicle: {this.props.subscription.vehicle.year} {this.props.subscription.vehicle.make} {this.props.subscription.vehicle.model}</h6>
              </div>
                <div className="col text-right mr-3">
                {(this.props.subscription.vehicle.vehicle_type.vtype == 'SEDAN') &&
                  <img className="icon"  width="15%" src={Sedan}></img>}
                {(this.props.subscription.vehicle.vehicle_type.vtype != 'SEDAN') &&
                    <img className="icon" width="15%" src={NonSedan}></img> }
                </div>
                </div>
            </div>
            <hr></hr>
            <div className="card-title">
              <div className="card-title bg-white">
                <div className="row no-gutters align-items-center">
                <div className="twoColumn">
                  <h6 className="halfDiv padding-ten">Subscription</h6>
                  <h6 className="halfDiv textAlignRight2">{this.props.subscription.subscription.name}</h6>
                </div>
                <div className="twoColumn">
                  <h6 className="halfDiv padding-ten">Frequency</h6>
                  <h6 className="halfDiv textAlignRight2">{this.props.subscription.subscription.frequency}</h6>
                </div>
                <div className="twoColumn">
                  <h6 className="halfDiv padding-ten">Start Date</h6>
                  <h6 className="halfDiv textAlignRight2">{this.props.subscription.start_date}</h6>
                </div>
                <div className="twoColumn">
                  <h6 className="halfDiv padding-ten">Base Amount</h6>
                  <h6 className="halfDiv textAlignRight2">${(this.props.subscription.base_amount/100).toFixed(2)}</h6>
                </div>
                <div className="twoColumn">
                  <h6 className="halfDiv padding-ten">Tax Amount</h6>
                  <h6 className="halfDiv textAlignRight2">${parseFloat((this.props.subscription.tax_amount/100).toFixed(2)).toFixed(2)}</h6>
                </div>
                <div className="twoColumn">
                  <h6 className="halfDiv padding-ten">Total</h6>
                  <h6 className="halfDiv textAlignRight2">${(parseFloat((this.props.subscription.base_amount/100).toFixed(2)) + parseFloat((this.props.subscription.tax_amount/100).toFixed(2))).toFixed(2)}</h6>
                </div>
              </div>
                <div className="card-title text-center mt-2 mb-0">
              </div>
              </div>
            </div>
          </div>
        </div>

              )
    }
}
export default SubscriptionSummary;



// WEBPACK FOOTER //
// ./src/Components/SubscriptionSummary.js